import { SwapContainer } from '@/features/swap/SwapContainer'

export function SwapPage() {
  return <SwapContainer isModal={false} withHeading isSwapPage={true} />
}
